import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLibModule } from '@nrwl/common-lib';
import { CommonMaterialModule } from '@nrwl/common-material';
import { NavigationAbstractLibModule } from '@nrwl/navigation-abstract';
import { ServiceTestModule } from '@nrwl/service-test';
import { TestSetupModule } from '@nrwl/test-setup';
import { TruespeedTestModule } from '@nrwl/truespeed-test';
import { TestSetupRouteStarterComponent } from './test-setup.route.starter.component';
import { TestSetupConfigService } from './service/test-setup-config.service';
import { TestSetupTemplateService } from './service/test-setup-template-config.service';
import { TestSetupAgentModelService } from './service/test-setup-agent-model.service';
import { TestSetupRouterService } from './test-setup-router.service';
import { TwampTestSetupConfigService } from './service/twamp-test-setup-config.service';

@NgModule({
  imports: [
    CommonModule,
    CommonLibModule,
    NavigationAbstractLibModule,
    TruespeedTestModule,
    ServiceTestModule,
    TestSetupModule,
    FormsModule,
    ReactiveFormsModule,
    CommonMaterialModule
  ],
  declarations: [TestSetupRouteStarterComponent],
  providers: [
    TestSetupAgentModelService,
    TestSetupConfigService,
    TestSetupTemplateService,
    TestSetupRouterService,
    TwampTestSetupConfigService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TestSetupRouterModule {}
